import React from 'react';
import marked from 'marked';

import { renderWhenTrue } from '../../utils';

import {
  Container,
  TextContent,
  Logo,
} from './alertBar.styled';
import { AlertBarData } from './alertBar.types';

export const AlertBar: React.FC<AlertBarData> = (data: AlertBarData) => {
  const {
    alertContent,
    logo,
    hasTextContent = true,
    hasLogoInBanner = true,
  } = data;

  const renderTextContent = renderWhenTrue(() => (
    <TextContent
      dangerouslySetInnerHTML={{__html: marked(alertContent)}}
    />
  ));

  const renderLogo = renderWhenTrue(() => (
    <Logo src={logo} />
  ));

  return (
    <Container alignEnd={!hasTextContent}>
      {renderTextContent(!!alertContent && hasTextContent)}
      {renderLogo(hasLogoInBanner)}
    </Container>
  );
}
